import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createWorkTimeEntryEntityInfo } from 'record-it-time-common/entity/entities/WorkTimeEntry/createWorkTimeEntryEntityInfo';
import { WorkTimeEntry } from './workTimeEntryTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export const workTimeEntryEntityInfo =
  createWorkTimeEntryEntityInfo<WorkTimeEntry>({
    additionalFieldInfos:
      EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
  });
